import React, { useEffect, useState } from "react";

import "./stylesTurnoverByType.css";

import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      beginAtZero: true,
      stacked: false,
    },
    y: {
      stacked: false,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    datalabels: {
      display: false,
      anchor: "end",
      align: "start",
      formatter: (value) => value.toLocaleString(),
      color: "black",
      font: {
        family: "Poppins-regular",
        weight: "bold",
      },
    },
    tooltip: {
      enabled: true,
      mode: "index",
      intersect: false,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(value)}`;
        },
      },
    },
  },
};

function TurnoverByType() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [isLoading, setIsLoading] = useState(false);

  const thisMonthRange = [dayjs().startOf("month"), dayjs().endOf("day")];
  const [dates, setDates] = useState(thisMonthRange);

  const [data, setData] = useState({
    labels: [],
    datasets: [],
  });

  const labels = [
    {
      label: "Single",
      backgroundColor: "#6177E8",
      borderRadius: 5,
    },
    {
      label: "Parlay",
      backgroundColor: "#E74C3C",
      borderRadius: 5,
    },
    {
      label: "Round Robin",
      backgroundColor: "#1ABC9C",
      borderRadius: 5,
    },
  ];

  const getTurnoverByTypeData = async (
    queryString = thisMonthRange,
    isQueryString = true
  ) => {
    let startDate = "";
    let endDate = "";

    if (isQueryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    }

    const params = {
      start_date: startDate,
      end_date: endDate,
    };

    try {
      setIsLoading(true);
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_MARGIN_BY_BET_TYPE,
        params
      );

      const data = response?.data?.data?.data;
      const parlayData = data.filter((item) => item.bet_type === "Parlay")[0]
        ?.data;
      const singleData = data.filter((item) => item.bet_type === "Single")[0]
        ?.data;
      const roundRobinData = data.filter(
        (item) => item.bet_type === "Round Robin"
      )[0]?.data;

      const parlayDataTotalTurnover = parlayData.map((item) => item.turnover);
      const singleDataTotalTurnover = singleData.map((item) => item.turnover);
      const roundRobinDataTotalTurnover = roundRobinData.map(
        (item) => item.turnover
      );

      const allDatesSet = new Set([
        ...parlayData.map((item) => item.date),
        ...singleData.map((item) => item.date),
        ...roundRobinData.map((item) => item.date),
      ]);

      const allDates = Array.from(allDatesSet);

      const chartData = {
        labels: allDates,
        datasets: [
          {
            label: "Single",
            data: singleDataTotalTurnover,
            backgroundColor: "#6177E8",
            borderRadius: 5,
          },
          {
            label: "Parlay",
            data: parlayDataTotalTurnover,
            backgroundColor: "#E74C3C",
            borderRadius: 5,
          },
          {
            label: "Round Robin",
            data: roundRobinDataTotalTurnover,
            backgroundColor: "#1ABC9C",
            borderRadius: 5,
          },
        ],
      };

      setData(chartData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTurnoverByTypeData(dates, false);
  }, []);

  return (
    <div className="turnover-by-type-container">
      <div className="turnover-by-type-header">
        <h2>Turnover by Type</h2>
        <CustomDatePicker
          getData={getTurnoverByTypeData}
          dates={dates}
          setDates={setDates}
          showPresets={true}
        />
      </div>

      <div className="turnover-by-type-chart">
        {isLoading ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="turnover-by-type-types">
              {labels.map((label) => (
                <div className="turnover-by-type-type" key={label.label}>
                  <div
                    className="turnover-by-type-type-icon"
                    style={{ backgroundColor: label.backgroundColor }}
                  ></div>
                  <span>{label.label}</span>
                </div>
              ))}
            </div>
            <div className="turnover-by-type-chart-container">
              <Bar data={data} options={options} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default TurnoverByType;
